import * as React from "react";
import { Action, Dispatch } from "redux";
import { connect } from "react-redux";

import { Contract } from "../../domain/model/contract";
import { Project } from "../../domain/model/project";
import { Customer } from "../../domain/model/customer";

import { AppState } from "../store/app_state";
import { ClientContractState } from "../store/client_contract_state";
import { createClientContractDetailActionCreator } from "../action/client_contract_action";
import {
  createClientContractDispatcher,
  IClientContractDispatcher,
} from "../dispatcher/client_contract_dispatcher";

import {
  CreateContractByClientRequest,
  UpdateContractByClientRequest,
  OpenCreateFormContractByClientRequest,
  ApproveContractByClientRequest,
} from "../request/contract_request";

import ClientContractComponent from "../component/client/contract/client_contract";
import { RouteComponentProps } from "react-router";

interface IProps
  extends RouteComponentProps<{
    companyId: string;
    projectId: string;
    customerId: string;
  }> {
  state: ClientContractState;
  dispatcher: IClientContractDispatcher;
}

interface IState {
  isInit: boolean;
}

export class ClientContract extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const req: OpenCreateFormContractByClientRequest =
      new OpenCreateFormContractByClientRequest();
    req.companyId = this.props.match.params.companyId;
    req.projectId = this.props.match.params.projectId;
    req.customerId = this.props.match.params.customerId;
    this.props.dispatcher.openCreateForm(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { match, state } = this.props;
    const { isInit } = this.state;

    const contract: Contract | null = state.contract;
    const project: Project | null = state.project;
    const customer: Customer | null = state.customer;
    const isLoading: boolean = state.isLoading;

    return (
      <ClientContractComponent
        isInit={isInit}
        isLoading={isLoading}
        match={match}
        contract={contract}
        project={project}
        customer={customer}
        handleCreateSubmit={this.handleCreateSubmit}
        handleUpdateSubmit={this.handleUpdateSubmit}
        handleApproveSubmit={this.handleApproveSubmit}
      />
    );
  }

  private handleCreateSubmit = (values: any): void => {
    const companyId: string = this.props.match.params.companyId;
    const projectId: string = this.props.match.params.projectId;
    const customerId: string = this.props.match.params.customerId;

    const req: CreateContractByClientRequest =
      new CreateContractByClientRequest();
    req.companyId = companyId;
    req.projectId = projectId;
    req.customerId = customerId;
    req.uploadFile = values.fileURLFileObject;

    this.props.dispatcher.createContract(req);
  };

  private handleUpdateSubmit = (values: any): void => {
    const req: UpdateContractByClientRequest =
      new UpdateContractByClientRequest();
    req.companyId = this.props.match.params.companyId;
    req.projectId = this.props.match.params.projectId;
    req.customerId = this.props.match.params.customerId;
    req.uploadFile = values.fileURLFileObject;
    this.props.dispatcher.updateContract(req);
  };

  private handleApproveSubmit = (contract: Contract): void => {
    const req: ApproveContractByClientRequest =
      new ApproveContractByClientRequest();
    req.projectId = contract.projectID;
    req.customerId = contract.customerID;
    this.props.dispatcher.approveContract(req);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientContractReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientContractDispatcher(
      dispatch,
      createClientContractDetailActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientContract);



// WEBPACK FOOTER //
// ./src/presentation/container/client_contract_container.tsx